import { QueryPageResult, RuntimeModel, http } from '@kunlun/dependencies';

/**
 * 免费原因选项列表
 *
 * @param {RuntimeModel} rModel
 * @return {*}
 */
export const queryFreeReasonList = async (rModel: RuntimeModel) => {
  const gql = `
    query {
      deliAriesSellerOrderFreeReasonQuery {
        queryPage(
          page: { currentPage: 1, size: 999 }
          queryWrapper: {
            rsql: "(1==1) and (1==1)"
            queryData: { freeReason: null }
          }
        ) {
          content {
            freeReason
          }
          totalPages
          totalElements
        }
      }
    }
  `;

  const res = await http.mutate<QueryPageResult<{ freeReason: string }>>(rModel.moduleName, gql);
  return res.data.deliAriesSellerOrderFreeReasonQuery.queryPage;
};


/**
 * 促销简码
 *
 * @param {RuntimeModel} rModel
 * @return {*}
 */
export const querySimpleCodeList = async (rModel: RuntimeModel, params: string) => {
  const gql = `
    query {
      deliAriesPromotionSimpleCodeQuery {
        queryPage(
          page: { currentPage: 1, size: 999 }
          queryWrapper: {
            rsql: "${ !params ? " (1==1) and (1==1)" : "(simpleCode=like='params') or (description=like='params" }"
            queryData: { }
          }
        ) {
          content {
                 description
                 simpleCode
                 id      
          }
          totalPages
          totalElements
        }
      }
    }
  `;

  const res = await http.mutate<QueryPageResult<{ id: string,simpleCode: string, description : string }>>(rModel.moduleName, gql);
  return res.data.deliAriesPromotionSimpleCodeQuery.queryPage;
};
